import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import { EntityList, PageHead } from '../../components/EntityList';
import { useEditorReturn } from '../../hooks/useEditorReturn';
import CreditPaymentEditor from './CreditPaymentEditor';

function NewCreditPaymentNew() {
	const { id } = useParams();
	const navigate = useNavigate();
	const { returnTo } = useEditorReturn();
	const backTo = returnTo || `/AdminScreen/credits/credit/${id}`;

	return (
		<EntityList>
			<Helmet>
				<title>Agregar Pago</title>
			</Helmet>
			<PageHead
				breadcrumb={[
					{ label: 'Inicio', to: '/AdminScreen' },
					{ label: 'Pasividades', to: '/AdminScreen/credits' },
					{ label: 'Agregar pago' },
				]}
				title='Agregar Pago'
				subtitle='Completá los datos para registrar el pago.'
			/>
			<CreditPaymentEditor
				mode='create'
				preloadCreditId={id}
				onCancel={() => navigate(backTo)}
				onSaved={() => navigate(backTo)}
				saveLabel='Agregar'
			/>
		</EntityList>
	);
}

export default NewCreditPaymentNew;
